import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./DashboardBanner.css";

const images = [
  "/blofin/banner1.png",
  "/blofin/banner2.png",
  "/blofin/banner3.png",
  "/blofin/banner4.png",
  "/blofin/banner5.png",
  "/blofin/banner6.png",
  "/blofin/banner7.png",
  "/blofin/banner8.png",
];

const DashboardBanner = () => (
  <div className="container">
    <Swiper
      modules={[Navigation, Pagination]}
      spaceBetween={24}
      slidesPerView={4}
      autoplay={{ delay: 4000, disableOnInteraction: false }}
      breakpoints={{
        1200: { slidesPerView: 4 },
        900: { slidesPerView: 2 },
        0: { slidesPerView: 1 },
      }}
      className="dashboardbanner-swiper pb-0"
    >
      {images.map((img, idx) => (
        <SwiperSlide key={idx}>
          <div
            className="dashboardbanner-img-card"
            style={{ backgroundImage: `url(${img})` }}
          ></div>
        </SwiperSlide>
      ))}
    </Swiper>
  </div>
);

export default DashboardBanner;
